import { useEffect, useRef } from "react";

export function useDocumentTitle(messages: { role: "user" | "assistant"; content: string }[]) {
	const originalTitle = useRef(document.title);
	const lastCount = useRef(0);

	useEffect(() => {
		const assistantMessages = messages.filter((m) => m.role === "assistant" && m.content);
		const count = assistantMessages.length;

		if (count > lastCount.current && lastCount.current > 0) {
			document.title = `• ${originalTitle.current}`;
			const timeout = setTimeout(() => {
				document.title = originalTitle.current;
			}, 2000);
			return () => clearTimeout(timeout);
		}
		lastCount.current = count;
	}, [messages]);

	useEffect(() => {
		const onFocus = () => {
			document.title = originalTitle.current;
		};
		window.addEventListener("focus", onFocus);
		return () => window.removeEventListener("focus", onFocus);
	}, []);
}
